const LiberiaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111757)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M4.57178 7.27305H35.4287C34.289 5.89297 32.9671 4.66914 31.5008 3.63672H8.49967C7.03334 4.66898 5.71154 5.89289 4.57178 7.27305Z"
        fill="#F0F0F0"
      />
      <path
        d="M0 19.9998C0 20.6128 0.0291406 21.2189 0.083125 21.818H39.9169C39.9709 21.2189 40 20.6128 40 19.9998C40 19.3867 39.9709 18.7806 39.9169 18.1816H0.083125C0.0291406 18.7806 0 19.3867 0 19.9998H0Z"
        fill="#F0F0F0"
      />
      <path
        d="M2.18123 29.0904H37.8194C38.4083 27.9383 38.8886 26.7218 39.2472 25.4541H0.753418C1.11193 26.7218 1.5924 27.9384 2.18123 29.0904Z"
        fill="#F0F0F0"
      />
      <path
        d="M8.49967 36.3639H31.5007C32.967 35.3314 34.2889 34.1076 35.4286 32.7275H4.57178C5.71154 34.1075 7.03334 35.3314 8.49967 36.3639Z"
        fill="#F0F0F0"
      />
      <path
        d="M0.75293 14.5455H39.2468C38.8882 13.2777 38.4079 12.0611 37.8189 10.9092H2.18082C1.59199 12.0611 1.11152 13.2777 0.75293 14.5455Z"
        fill="#F0F0F0"
      />
      <path
        d="M9.56494 3.63633H31.5003C28.2471 1.34586 24.2807 0 19.9997 0C17.391 0 12.8181 1.34586 9.56494 3.63633Z"
        fill="#D80027"
      />
      <path
        d="M19.1304 10.9088H37.819C37.1539 9.60777 36.3506 8.3891 35.4283 7.27246H19.1304V10.9088Z"
        fill="#D80027"
      />
      <path
        d="M19.1304 18.1822H39.9168C39.8043 16.9336 39.5782 15.7177 39.2469 14.5459H19.1304V18.1822Z"
        fill="#D80027"
      />
      <path
        d="M0.753008 25.4547H39.2468C39.5782 24.283 39.8043 23.067 39.9168 21.8184H0.0830078C0.195508 23.067 0.421602 24.2829 0.753008 25.4547Z"
        fill="#D80027"
      />
      <path
        d="M4.57129 32.7271H35.4282C36.3504 31.6104 37.1537 30.3918 37.8188 29.0908H2.18066C2.84574 30.3918 3.64902 31.6105 4.57129 32.7271Z"
        fill="#D80027"
      />
      <path
        d="M19.9996 39.9996C24.2806 39.9996 28.247 38.6537 31.5001 36.3633H8.49902C11.7521 38.6537 15.7186 39.9996 19.9996 39.9996Z"
        fill="#D80027"
      />
      <path
        d="M0.75293 14.5455C0.421523 15.7173 0.195508 16.9332 0.0830078 18.1818H19.9999V0C10.8452 0 3.1273 6.15094 0.75293 14.5455Z"
        fill="#0052B4"
      />
      <path
        d="M11.9053 5.2168L13.2002 9.20234H17.3913L14.0008 11.6658L15.2957 15.6516L11.9053 13.1883L8.51475 15.6516L9.8099 11.6658L6.41943 9.20234H10.6103L11.9053 5.2168Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111757">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default LiberiaSvg;
